const $ = require('jquery');
const popup = require('./popup.js');
const FlashMessageStore = require('./../flux/stores/FlashMessageStore.js');
const get = require('lodash/get');

window.focusAndGo = function (url) {
  window.focus();
  window.location.href = url;
};

module.exports = {
  init() {
    const file_input = $('.registrationForm-fileInput');
    $(document).on('click', '.registrationForm-fileButton', (e) => {
      e.preventDefault();
      file_input.click();
      $('#MembersPhotoPlaceholder').val(file_input.val());
    });
    file_input.change((e) => {
      $('#MembersPhotoPlaceholder').val(file_input.val());
      $('.registrationForm-fileName').removeClass('is-hidden');
    });

    $('#MemberRegister, #MemberExternalRegister').submit(function () {
      $(this).submit(() => false);
      $(this).find("input[type='submit']").addClass('btn--disabled');

      return true;
    });
    // Lai paslēpj paroles lauku, ja neievada epastu (external)
    $(document).ready(() => {
      $('#register-resend-code').on('click', (e) => {
        e.preventDefault();
        const url = `${get(globals, 'webroot', '/')}auth/resend_code.json?only_resend=1`;
        $.get(url, (data) => {
          if (data.flash_type === 'success') {
            $('input[name="code"]').siblings('.error').slideUp(200, function() {
              $('input[name="code"]').parent('.form-group').removeClass('error');
            });
            $('#register-resend-code').slideUp(200);
          }
          FlashMessageStore.removeAll();
          FlashMessageStore.add(Math.floor(Date.now() / 1000), data.flash_type, data.message);
          FlashMessageStore.emitChange();
        });
      });
      $("[name='email']").change(function (e) {
        const $password = $('#external_password');
        if ($(this).val() !== '') {
          if ($password.hasClass('hide')) {
            $password.removeClass('hide');
          }
        } else if (!$password.hasClass('hide')) {
          $password.addClass('hide');
        }
      });

      function PreviewImages() {
        const inputID = document.getElementById('photo');
        let element1 = '';
        let elementID = '';

        elementID = 'img';
        element1 = document.createElement('img');
        element1.name = elementID;
        element1.id = elementID;
        document.getElementById('registrationForm-imagePreview').appendChild(element1);

        oFReader = new FileReader();

        oFReader.onload = function (oFREvent) {
          const dataURI = oFREvent.target.result;
          const image = document.getElementById(elementID);
          image.src = dataURI;
        };

        oFReader.readAsDataURL(document.getElementById('photo').files[0]);
      }

      if (window.FileReader) {
        window.addEventListener('load', () => {
          var el = document.getElementById('photo');
          if (el) {
            el.addEventListener('change', PreviewImages, false);
          }
        }, false);
      }
    });
  },
};
